import {
  SKILL_TEST_OPEN,
  SKILL_TEST_OPTION_SELECTED,
  SKILL_TEST_ANSWERED,
  PLAY_NOW_OPEN,
  GAME_INFO_OPEN,
  HISTORY_OPEN,
  PLAY_NOW_CLICK,
  GAME_INFO_CLICK,
  HISTORY_CLICK,
  LEADERBOARD_CLICK,
  PICKS_SUBMITTED,
  PICKS_AUTO_SELECTED,
  HEAT_STREAK_PANEL_SELECTED,
  LEADERBOARD_OPEN,
  LEADERBOARD_SEASON_TAB_SELECTED,
  LEADERBOARD_MONTHLY_TAB_SELECTED,
  LEADERBOARD_PLAYOFFS_TAB_SELECTED,
  // AEP
  CLICKED_TYPE,
  VIEWED_TYPE,
  MODAL_OPENED_TYPE,
  SKILL_TESTING_QUESTION,
  NOTIFICATIONS,
  ONBOARDING,
  SUBMIT_ELEMENT,
  PLAY_NOW_ELEMENT,
  SUBMIT_PICKS_ELEMENT,
  RANDOMLY_SELECT_PLAYERS_ELEMENT,
  HISTORY_ELEMENT,
  LEADERBOARD_ELEMENT,
  GAME_INFO_ELEMENT,
  USER_STATS_ELEMENT,
  MAKE_YOUR_PICKS_ELEMENT,
  BUTTON_TYPE,
  TOGGLE_TYPE,
  TAB_TYPE,
  POPUP_TYPE,
  ON_VALUE,
  OFF_VALUE,
  PATH,
  CORRECT_VALUE,
  INCORRECT_VALUE,
  ANSWER_ELEMENT,
  LEADERBOARD_SEASON_ELEMENT,
  LEADERBOARD_MONTHLY_ELEMENT,
  LEADERBOARD_PLAYOFFS_ELEMENT,
  SEE_YOUR_POSITION,
  SCROLL_TO_TOP,
} from '../lib/constants';

const analyticActionMap = {
  quizOpen: SKILL_TEST_OPEN,
  quizOptionSelected: SKILL_TEST_OPTION_SELECTED,
  quizAnswered: SKILL_TEST_ANSWERED,
  playNowOpen: PLAY_NOW_OPEN,
  gameInfoOpen: GAME_INFO_OPEN,
  historyOpen: HISTORY_OPEN,
  leaderboardOpen: LEADERBOARD_OPEN,
  playNowClick: PLAY_NOW_CLICK,
  gameInfoClick: GAME_INFO_CLICK,
  historyClick: HISTORY_CLICK,
  leaderboardClick: LEADERBOARD_CLICK,
  picksSubmitted: PICKS_SUBMITTED,
  picksAutoSelected: PICKS_AUTO_SELECTED,
  heatStreakPanelSelected: HEAT_STREAK_PANEL_SELECTED,
  leaderboardSeasonTabSelected: LEADERBOARD_SEASON_TAB_SELECTED,
  leaderboardMonthlyTabSelected: LEADERBOARD_MONTHLY_TAB_SELECTED,
  leaderboardPlayoffsTabSelected: LEADERBOARD_PLAYOFFS_TAB_SELECTED,
  // AEP
  clickedType: CLICKED_TYPE,
  viewedType: VIEWED_TYPE,
  modalOpenedType: MODAL_OPENED_TYPE,
  skillTestAnswered: SKILL_TEST_ANSWERED,
  skillTestQuestion: SKILL_TESTING_QUESTION,
  notifications: NOTIFICATIONS,
  onboarding: ONBOARDING,
  submitElement: SUBMIT_ELEMENT,
  answerElement: ANSWER_ELEMENT,
  playNow: PLAY_NOW_ELEMENT,
  submitPicks: SUBMIT_PICKS_ELEMENT,
  randomlySelectPlayers: RANDOMLY_SELECT_PLAYERS_ELEMENT,
  history: HISTORY_ELEMENT,
  leaderboard: LEADERBOARD_ELEMENT,
  leaderboardSeason: LEADERBOARD_SEASON_ELEMENT,
  leaderboardMonthly: LEADERBOARD_MONTHLY_ELEMENT,
  leaderboardPlayoffs: LEADERBOARD_PLAYOFFS_ELEMENT,
  gameInfo: GAME_INFO_ELEMENT,
  userStats: USER_STATS_ELEMENT,
  makeYourPicks: MAKE_YOUR_PICKS_ELEMENT,
  seeYourPosition: SEE_YOUR_POSITION,
  scrollToTop: SCROLL_TO_TOP,
  buttonType: BUTTON_TYPE,
  toggleType: TOGGLE_TYPE,
  tabType: TAB_TYPE,
  popupType: POPUP_TYPE,
  onValue: ON_VALUE,
  offValue: OFF_VALUE,
  correctValue: CORRECT_VALUE,
  incorrectValue: INCORRECT_VALUE,
  path: PATH,
};

export { analyticActionMap };
